import { createAction } from '@reduxjs/toolkit';

import { Transaction } from 'models/transaction';

export const setTransactionsPeriod = createAction('data/setTransactionsPeriod');
export const updateTransactionFromPusher = createAction<Transaction>(
  'data/updateTransactionFromPusher',
);
export const clearTransaction = createAction('data/clearTransaction');
